import { useCredits } from '@/contexts/CreditsContext';
import { Coins } from 'lucide-react';

const TIER_LABELS = {
  free: 'Free',
  pro: 'Pro',
  business: 'Business',
  enterprise: 'Enterprise',
};

const TIER_COLORS = {
  free: 'var(--orbis-t4)',
  pro: 'var(--orbis-blue)',
  business: 'var(--orbis-amber)',
  enterprise: 'var(--orbis-positive)',
};

export default function CreditMeter({ compact = false }) {
  const { balance, tier, loading } = useCredits();

  if (loading) return null;

  const isLow = balance < 10 && tier === 'free';
  const tierLabel = TIER_LABELS[tier] || tier;
  const tierColor = TIER_COLORS[tier] || 'var(--orbis-t4)';

  if (compact) {
    return (
      <div className="flex items-center gap-1.5" style={{ fontFamily: 'var(--orbis-font)' }}>
        <Coins className="w-3.5 h-3.5" style={{ color: isLow ? '#F59E0B' : 'var(--orbis-t3)' }} />
        <span style={{
          fontSize: 11,
          fontFamily: 'var(--orbis-mono)',
          fontWeight: 500,
          color: isLow ? '#F59E0B' : 'var(--orbis-t2)',
        }}>
          {balance}
        </span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2.5" style={{ fontFamily: 'var(--orbis-font)' }}>
      {/* Credits count */}
      <div className="flex items-center gap-1.5">
        <Coins className="w-3.5 h-3.5" style={{ color: isLow ? '#F59E0B' : 'var(--orbis-t3)' }} />
        <span style={{
          fontSize: 12,
          fontFamily: 'var(--orbis-mono)',
          fontWeight: 500,
          color: isLow ? '#F59E0B' : 'var(--orbis-t2)',
          letterSpacing: '0.02em',
        }}>
          {balance}
        </span>
      </div>

      {/* Tier badge */}
      <span style={{
        fontSize: 9,
        fontFamily: 'var(--orbis-mono)',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '1px',
        padding: '3px 8px',
        borderRadius: 'var(--orbis-r-pill)',
        border: `0.5px solid ${tierColor}40`,
        color: tierColor,
        background: `${tierColor}10`,
      }}>
        {tierLabel}
      </span>
    </div>
  );
}
